var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{class:[_vm.variant ? 'text-' + _vm.variant : '', _vm.linkClass],attrs:{"variant":"sheet","to":_vm.to,"href":_vm.href,"target":_vm.target},on:{"click":_vm.onClick}},[(_vm.icon)?_c('i',{staticClass:"action-sheet-icon fa-fw",class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }